import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/dashboard'
    },{
      path:'/',
      component:resolve=>require(['../components/common/home.vue'],resolve),
      meta:{title:'导航菜单'},
      children:[
        {
          path:'/dashboard',
          component:resolve=>require(['../components/pages/dashboard'],resolve),
          meta:{title:'系统首页'}
        },        {
          path:'/abnormal',
          component:resolve=>require(['../components/pages/dashboardIndex/abnormal'],resolve),
          meta:{title:'异常提醒'}
        },{
          path:'/agent',
          component:resolve=>require(['../components/pages/index/agent'],resolve),
          meta:{title:'统计汇总'}
        },{
          path:'/adminUser',
          component:resolve=>require(['../components/pages/merchant/adminUser'],resolve),
          meta:{title:'管理员账号'}
        },{
          path:'/newUsername',
          component:resolve=>require(['../components/pages/merchant/newUsername'],resolve),
          meta:{title:'添加账号'}
        },{
          path:'/deviceAutho',
          component:resolve=>require(['../components/pages/deviceManagement/deviceAutho'],resolve),
          meta:{title:'设备授权'}
        },{
          path:'/deviceDetails',
          component:resolve=>require(['../components/pages/deviceManagement/deviceDetails'],resolve),
          meta:{title:'设备授权详情'}
        },{
          path:'/cabinetMange',
          redirect:'/cabinetRegister',
          component:resolve=>require(['../components/pages/deviceManagement/cabinetMange'],resolve),
          meta:{title:'柜机管理'},
          children:[
            {                                     //三级路由
              path:'/cabinetRegister',
              name:'/cabinetRegister',
              meta:{title:'柜机注册'},
              component:resolve=>require(['../components/pages/deviceManagement/cabinetRegister'],resolve),
            }, {                                     //三级路由
              path:'/registerDetails',
              name:'/registerDetails',
              meta:{title:'注册详情'},
              component:resolve=>require(['../components/pages/deviceManagement/registerDetails'],resolve),
            },{                                     //三级路由
              path:'/cabinetDispose',
              name:'/cabinetDispose',
              meta:{title:'柜机配置'},
              component:resolve=>require(['../components/pages/deviceManagement/cabinetDispose'],resolve),
            },{
              path:'/remoteUpgrade',
              name:'remoteUpgrade',
              meta:{title:'远程升级'},
              component:resolve=>require(['../components/pages/deviceManagement/remoteUpgrade'],resolve),
            },{
              path:'/updateDetails',
                name:'updateDetails',
                meta:{title:'柜机系统详情'},
              component:resolve=>require(['../components/pages/deviceManagement/updateDetails'],resolve),
            },{
              path:'/latticeLock',
              name:'latticeLock',
              meta:{title:'格口锁定'},
              component:resolve=>require(['../components/pages/deviceManagement/latticeLock'],resolve),
            },{
              path:'/lockDetails',
                name:'lockDetails',
              meta:{title:'格口锁定详情'},
              component:resolve=>require(['../components/pages/deviceManagement/lockDetails'],resolve),
            },{
              path:'/patientEdu',
              name:'patientEdu',
              meta:{title:'患者教育'},
              component:resolve=>require(['../components/pages/deviceManagement/patientEdu'],resolve),
            },{
              path:'/eduDetails',
              name:'eduDetails',
              meta:{title:'患者教育详情'},
              component:resolve=>require(['../components/pages/deviceManagement/eduDetails'],resolve),
            },{
              path:'/videoUpdate',
              name:'videoUpdate',
              meta:{title:'视频更新'},
              component:resolve=>require(['../components/pages/deviceManagement/videoUpdate'],resolve),
            },{
              path:'/remoteMonitor',
              name:'remoteMonitor',
              meta:{title:'远程监控'},
              component:resolve=>require(['../components/pages/deviceManagement/remoteMonitor'],resolve),
            },{
              path:'/remoteDetails',
              name:'remoteDetails',
              meta:{title:'远程监控'},
              component:resolve=>require(['../components/pages/deviceManagement/remoteDetails'],resolve),
            },{
              path:'/cabinetDetails',
              name:'cabinetDetails',
              meta:{title:'柜机配置详情'},
              component:resolve=>require(['../components/pages/deviceManagement/cabinetDetails'],resolve),
            },{
              path:'/cabbinetAutho',
              name:'cabbinetAutho',
              meta:{title:'柜机授权'},
              component:resolve=>require(['../components/pages/deviceManagement/cabbinetAutho'],resolve),
            }]

        },{
          path:'/atomizationManage',
          redirect:'/atomizationRegister',
          component:resolve=>require(['../components/pages/deviceManagement/atomizationManage'],resolve),
          meta:{title:'雾化工位'},
          children:[
            {                                     //三级路由
              path:'/atomizationRegister',
              name:'/atomizationRegister',
              meta:{title:'雾化工位配置'},
              component:resolve=>require(['../components/pages/deviceManagement/atomizationRegister'],resolve),
            },{                                     //三级路由
              path:'/atomizationRegisterDetails',
              name:'/atomizationRegisterDetails',
              meta:{title:'雾化工位配置'},
              component:resolve=>require(['../components/pages/deviceManagement/atomizationRegisterDetails'],resolve),
            },{                                     //三级路由
              path:'/atomizationConfig',
              name:'/atomizationConfig',
              meta:{title:'雾化工位配置'},
              component:resolve=>require(['../components/pages/deviceManagement/atomizationConfig'],resolve),
            },{                                     //三级路由
              path:'/updateAtomization',
              name:'/updateAtomization',
              meta:{title:'雾化工位修改'},
              component:resolve=>require(['../components/pages/deviceManagement/updateAtomization'],resolve),
            },{                                     //三级路由
              path:'/atomizationAutho',
              name:'/atomizationAutho',
              meta:{title:'雾化工位授权'},
              component:resolve=>require(['../components/pages/deviceManagement/atomizationAutho'],resolve),
            }, {
              path:'/atomizationRemoteUpgrade',
              name:'atomizationRemoteUpgrade',
              meta:{title:'远程升级'},
              component:resolve=>require(['../components/pages/deviceManagement/atomizationRemoteUpgrade'],resolve),
            },{
              path:'/atomizationRemoteDetails',
              name:'atomizationRemoteDetails',
              meta:{title:'远程升级详情'},
              component:resolve=>require(['../components/pages/deviceManagement/atomizationRemoteDetails'],resolve),
            }]

        },{
          path:'/account',
          name:'account',
          meta:{title:'账号管理'},
          component:resolve=>require(['../components/pages/customerManage/account'],resolve),
        },{
          path:'/newAccount',
          name:'cabbinetAutho',
          meta:{title:'编辑账号'},
          component:resolve=>require(['../components/pages/customerManage/newAccount'],resolve),
        },{
          path:'/product',
          name:'product',
          meta:{title:'产品管理'},
          component:resolve=>require(['../components/pages/customerManage/product'],resolve),
        },{
          path:'/newProduct',
          name:'newProduct',
          meta:{title:'编辑产品'},
          component:resolve=>require(['../components/pages/customerManage/newProduct'],resolve),
        },{
          path:'/applyManage',
          name:'applyManage',
          redirect:'/storeApply',
          meta:{title:'申请管理'},
          component:resolve=>require(['../components/pages/customerManage/applyManage'],resolve),
          children:[{
            path:'/storeApply',
            name:'storeApply',
            meta:{title:'店铺申请'},
            component:resolve=>require(['../components/pages/customerManage/storeApply'],resolve),
          },{
            path:'/goodsNewsApply',
            name:'goodsNewsApply',
            meta:{title:'商品申请'},
            component:resolve=>require(['../components/pages/customerManage/goodsNewsApply'],resolve),
          },{
            path:'/storeDetails',
            name:'storeDetails',
            meta:{title:'商品申请'},
            component:resolve=>require(['../components/pages/customerManage/storeDetails'],resolve),
          },{
            path:'/mallApply',
            name:'mallApply',
            meta:{title:'商品申请'},
            component:resolve=>require(['../components/pages/customerManage/mallApply'],resolve),
          }]
        },{
          path:'/storeManagement',
          name:'storeManagement',
          meta:{title:'店铺管理'},
          component:resolve=>require(['../components/pages/customerManage/storeManagement'],resolve),
        },{
          path:'/storeEveryDetails',
          name:'storeEveryDetails',
          meta:{title:'店铺详情'},
          component:resolve=>require(['../components/pages/customerManage/storeEveryDetails'],resolve),
        },{
          path:'/statisList',
          component:resolve=>require(['../components/pages/statis/statisList'],resolve),
          meta:{title:'结算清单'}
        },{
          path:'/statisDetails',
          component:resolve=>require(['../components/pages/statis/statisDetails'],resolve),
          meta:{title:'结算清单详情'}
        },{
          path:'/allOrder',
          component:resolve=>require(['../components/pages/statis/allOrder'],resolve),
          meta:{title:'全部订单'}
        },{
          path:'/dzdList',
          component:resolve=>require(['../components/pages/statis/dzdList'],resolve),
          meta:{title:'全部订单'}
        },{
          path:'/orderRentDetails',
          component:resolve=>require(['../components/pages/statis/orderRentDetails'],resolve),
          meta:{title:'租赁订单'}
        },{
          path:'/orderRentTimeDetails',
          component:resolve=>require(['../components/pages/statis/orderRentTimeDetails'],resolve),
          meta:{title:'租赁订单'}
        }, {
          path:'/orderMallDetails',
          component:resolve=>require(['../components/pages/statis/orderMallDetails'],resolve),
          meta:{title:'销售订单'}
        },{
          path:'/diversion',
          name:'diversion',
          meta:{title:'导流申请'},
          component:resolve=>require(['../components/pages/Diversion/diversion'],resolve),
        },{
          path:'/diversionDetails',
          name:'diversionDetails',
          meta:{title:'导流信息'},
          component:resolve=>require(['../components/pages/Diversion/diversionDetails'],resolve),
        },{
          path:'/coupon',
          name:'coupon',
          meta:{title:'优惠券'},
          component:resolve=>require(['../components/pages/Diversion/coupon'],resolve),
        },{
          path:'/couponDetails',
          name:'couponDetails',
          meta:{title:'优惠券详情'},
          component:resolve=>require(['../components/pages/Diversion/couponDetails'],resolve),
        }]
    },{
      path: '/Login',
      component: resolve => require(['../components/login/Login.vue'], resolve)
    },
  ]
});





// WEBPACK FOOTER //
// ./src/router/index.js